import { CollectionApiFormat } from '@/src/lib/http/jsonapi/deserializer';
import { CatalogSearchSuggestionAttributes } from '@/src/lib/category/types';
import { createClient } from '@/src/lib/http/client/client';
import { getDialectForLocale } from '@/src/lib/dictionary/utils';

export default async function getCatalogSearchSuggestionsClient(searchTerm: string, locale = 'en') {
  const client = createClient();
  const res = await client.get(`/catalog-search-suggestions?q=${searchTerm}`, {
    headers: new Headers({ 'Accept-Language': getDialectForLocale(locale) }),
  });

  return client.handleResponse<CollectionApiFormat<CatalogSearchSuggestionAttributes>>(res);
}
